module.exports = __webpack_public_path__ + "img/future2.de648d34.png";